module.exports = __webpack_public_path__ + "static/media/user-20.0e199d15.svg";